import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { Component } from "@/types/diagram";
import { useMutation } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";

type SaveComponentRequest = {
  component: Component;
  category: string;
};

export const saveComponent = async (
  payload: SaveComponentRequest & { token: string }
): Promise<Component | undefined> => {
  const body = {
    name: payload.component.name,
    type: "COMPONENT",
    attachTo: "",
    svgContent: payload.component.svgContent,
    version: "1.0.0",
    category: payload.category,
    metadata: {
      description: payload.component.description,
    },
    diagram_components: payload.component.diagramComponents,
    attachment_points: payload.component.attachmentPoints,
  };

  const url = `${config.isometricApiUrl}/shapes`;
  try {
    const response = await apiFetch(url, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${payload.token}`,
      },
    });
    if (!response.ok) {
    const errorData = await response.json();
    const error: any = new Error(errorData.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
    return await response.json();
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export default function useSaveComponent(
  onSettled?: (res: any | undefined, error: Error | null) => void
) {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (params: SaveComponentRequest) => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace("Bearer ", "");
      return saveComponent({ ...params, token });
    },
    onSettled,
  });
}
